import { PRINT_BLEED_CENTER_GAP_PT, PRINT_BLEED_MARGIN_PT } from '@/lib/document/print-bleed'
import type { CenterCanvasConfig } from '../types/center-canvas-config'

/**
 * `CenterCanvas` prop defaults, applied by `applyCenterCanvasDefaults` only when a prop is
 * `undefined` (never for `null`), exactly as the inline destructuring defaults they replace did.
 * `unifiedLayerIds` is defaulted there too, but not here: it needs a fresh array per render.
 */
export const CENTER_CANVAS_DEFAULTS = {
  pageViewMode: 'spread',
  gridMode: 'full',
  showGuides: true,
  showSmartGuides: true,
  snapToGuides: true,
  snapGuideDistance: 8,
  zoom: 1,
  columns: 0,
  rows: 0,
  colGutter: 24,
  rowGutter: 24,
  bleedWidth: 1248,
  bleedHeight: 816,
  trimWidth: 1224,
  trimHeight: 792,
  bleedMargin: PRINT_BLEED_MARGIN_PT,
  liveInset: 28,
  centerGap: PRINT_BLEED_CENTER_GAP_PT,
  marginInside: 0,
  marginOutside: 28,
  marginTop: 28,
  marginBottom: 28,
  showLeftPageGuides: true,
  showRightPageGuides: true,
  selectedShape: null,
  isPenToolActive: false,
  penToolDefaultPointType: 'corner',
  checkpointDiagnostics: null,
  photoEffectsOpen: false,
  nudgeDistancePt: 1,
  snapToGrid: true,
  showBleed: true,
  isPanModeActive: false,
  mirrorMoveHoverActive: false,
  isTextToolActive: false,
  showTextLinking: false,
} as const satisfies Partial<CenterCanvasConfig>
